import { t } from 'utils';

const disciplines = {
  _validation: {
    title: {
      presence: {
        message: () => t.staticAsString('shared.errors.presence'),
        allowEmpty: false,
      },
      length: {
        minimum: 1,
        maximum: 50,
      },
    },
  },
};

export { disciplines };
